import _ from 'lodash';
import DataProvider from '../app/data-framework/data-provider';
import Router from './router';
import LoginRoutes from './routes/login.routes';
import AssuranceRoutes from './routes/assurance';
import AdvancedAnalyticsRoutes from './routes/advanced-analytics';
import RoomInsightsRoutes from './routes/room-insights';
import DeveloperPortalRoutes from './routes/developer-portal';

// import page components
import '../modules/termsOfService/termsOfServiceView';
import adminView from "../modules/admin/ko/adminView";


export default {
  getRouter: function(dataProvider) {
    return new Router({
      routes: _.concat([],
        // ROUTE ORDER MATTERS!:: Crossroads will trigger the first route that matches
        // note: walkme permalinks (?walkme=34234) need to be supported manually for any RegExp added here
        //       we automatically add the necessary options :?query: to all string routes
        LoginRoutes,
        {url: 'termsOfService', params: { page: 'terms-of-service-view', view: 'terms-of-service-view' } },
        AssuranceRoutes,
        DeveloperPortalRoutes,
        // There are two potential quality routes:
        //     "/quality/{callId}" where callId could include slashes (e.g. Zoom call ids),
        //     "/quality/{systemId}/{callId}?nosave=true" where systemId is a numeric sequence.
        { url: /quality(?:\/(\d+))?\/([^?]+)/, params: { page: 'quality-container-view', view: 'quality-view', level: 'filter', regexGroups: ['systemId', 'callId'] } },
        AdvancedAnalyticsRoutes, // AA routes must go before Historical routes (otherwise historical2 will match first the historical catch all route)
        RoomInsightsRoutes,
        { url: /admin.*/, params: { page: 'admin-view', view: 'admin-view' } },
      )
    }, dataProvider);
  }
};
